export default "__VITE_PUBLIC_ASSET__7d30107b__"